// Dados específicos para os destaques da página inicial
export interface HomeMenuItem {
  name: string;
  description: string;
  price: string;
  image: string;
  fallbackImage?: string; // Adicionei a propriedade fallbackImage
  imageWidth?: number; // Adicionei a propriedade imageWidth
  imageHeight?: number; // Adicionei a propriedade imageHeight
  category?: string;
  ifoodUrl?: string;
}

export const homeMenuItems: HomeMenuItem[] = [
   {
    name: "Xis Salada",
    description: "Hamburguer Artesanal, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Queijo, Ovo",
    price: "R$ 31,00",
    image: "https://i.postimg.cc/hv7Chrcp/IMG-20250522-221835385-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=5eb6dfbb-e4c3-461a-ad19-ee6e04be31c3"
  },
   {
    name: "Xis Bacon",
    description: "Hamburguer Artesanal, Bacon, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Queijo, Ovo",
    price: "R$ 38,50",
    image: "https://i.postimg.cc/SKyyyg6R/IMG_20250604_203651060_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=5eb6dfbb-e4c3-461a-ad19-ee6e04be31c3"
  },
  {
    name: "Xis Calabresa",
    description: " Acompanha maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 32,90",
    image: "https://i.postimg.cc/gk5q7RyK/IMG-20250522-201140159-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=5a73aae8-1a96-4b0f-948d-cca9c082fd5c"
  },
  {
    name: "Xis Frango",
    description: "Acompanha maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 32,90",
    image: "https://i.postimg.cc/VN8Qtfpt/IMG-20250526-201322482-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=60222e84-34f0-4fa4-8941-3a4bccd3f98f"
  },
  {
    name: "Xis Coração",
    description: "Acompanha maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 33,90",
    image: "https://i.postimg.cc/ydxSFc5J/IMG-20250524-193236130-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=78139c90-c746-45ec-b544-b4078b87ff3a"
  },
  {
    name: "Xis Acebolado",
    description: "Hamburguer Artesanal, Cebola, Maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 31,90",
    image: "https://i.postimg.cc/j51nvC0M/IMG-20250524-192014192-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=b6176dfe-814d-44ab-81be-6fd75c5ceefb"
  },
   {
    name: "Xis Picanha",
    description: " Acompanha Maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 31,90",
    image: " https://i.postimg.cc/43C19gCD/IMG-20250523-212531398-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: ""
  },
  {
    name: " Xis Atum Acebolado",
    description: " Acompanha Maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 36,00",
    image: "https://i.postimg.cc/zXXpYYDm/IMG-20250530-203424628-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOop2m74UGAr3MVTlgGKCA_A9aZhu3J0tsjezeQ1OHyLvoWDV1KA0&prato=cbe412b2-5a1d-4907-9050-1f524720bada"
  },
   {
    name: "Xis Strogonoff",
    description: "Iscas De Carne, Creme De Leite, Molho, Champignon, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 42,50",
    image: "https://i.postimg.cc/tCth57CB/IMG-20250521-204112614-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOopL7eS9ZrMiPBp6zmEZNcRExevkXAjYa9BMc6nmXxslNXSueTNX&prato=1181331c-1ef6-4c29-94b5-986899a592c0"
  },
   {
    name: "Xis Fricassé",
    description: "Frango, Creme De Leite, Molho, Champignon, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 42,50",
    image: "https://i.postimg.cc/sDWjQyw2/IMG_20250607_212947806_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOopL7eS9ZrMiPBp6zmEZNcRExevkXAjYa9BMc6nmXxslNXSueTNX&prato=758c9e22-1658-4f7c-81b4-173f7cff7b40"
  },
   {
    name: "Xis Brocolis Com Catupiry",
    description: "Brocolis, Catupiry, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 36,00",
    image: "https://i.postimg.cc/h4Hb7pjK/IMG-20250515-WA0074.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOopL7eS9ZrMiPBp6zmEZNcRExevkXAjYa9BMc6nmXxslNXSueTNX&prato=fb53666b-91f6-469b-b894-bfc3dfaa826b"
  },
  {
    name: "Xis 4 Queijos",
    description: "Acompanha maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo Mussarela, Parmesão, Provolone E Gorgonzola.",
    price: "R$ 32,90",
    image: "https://i.postimg.cc/7LYgyRBn/IMG-20250515-WA0070.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=5c6786e3-98e1-4a63-81fc-a2417f45d0b4"
  },
   {
    name: "Xis Filé",
    description: "Acompanha maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo Mussarela, Parmesão, Provolone E Gorgonzola.",
    price: "R$ 49,50",
    image: "https://i.postimg.cc/zfFSRBR7/IMG_20250603_210023600_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=5c6786e3-98e1-4a63-81fc-a2417f45d0b4"
  },
  {
    name: "Xis K-recão",
    description: "Acompanha frango,coração, calabresa, bacon, carne, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 49,00",
    image: "https://i.postimg.cc/Mpv8DJZF/IMG-20250521-194748565-PORTRAIT-3.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=47e56877-8690-4573-b568-0a45da6ffbfc"
  },
  {
    name: "Xis A Portuguesa C/File",
    description: "Acompanha file, cebola, azeitona, pimentão, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 57,00",
    image: "https://i.postimg.cc/yxf2SW7Z/IMG_20250606_202543125_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqtOIT3z6PJZTXKaQsHNpk_ZAOXD9NUJ9Y7WlvYkFMZxss5wVIF&prato=c46c7719-8ee3-4d9c-9d0d-d4933c095f0c"
  },
   {
    name: "Xis Misto Coração + Calabresa",
    description: "Acompanha coração, calabresa, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 49,00",
    image: "https://i.postimg.cc/FsVqN9Ty/IMG-20250603-203241773-PORTRAIT-3.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=47e56877-8690-4573-b568-0a45da6ffbfc"
  },
  {
    name: "Xis Misto Frango + Bacon",
    description: "Acompanha coração, calabresa, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 49,00",
    image: "https://i.postimg.cc/7PnPRCpw/IMG_20250604_225242440_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=47e56877-8690-4573-b568-0a45da6ffbfc"
  },
  {
    name: "Xis Misto Coração + Bacon",
    description: "Acompanha coração, calabresa, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
    price: "R$ 49,00",
    image: "https://i.postimg.cc/sX1BvF6X/IMG_20250605_204453703_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=47e56877-8690-4573-b568-0a45da6ffbfc"
  },
  {
    name: "Xis Misto Coração + Frango",
    description: "Acompanha coração, Frango, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo.",
     price: "R$ 49,00",
    image: "https://i.postimg.cc/nLvnQfr1/IMG_20250627_223639980_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=47e56877-8690-4573-b568-0a45da6ffbfc"
  },
  {
    name: "Stogonoff especial ",
    description: "Iscas De Carne, Creme De Leite, Molho, Champignon, maionese, tomate, alface, milho, mostarda, catchup, ovo e queijo. pessoas (1100g).",
    price: "R$ 68,00",
    image: "https://i.postimg.cc/YCPvx7pK/IMG_20250613_224340976_PORTRAIT_3.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=88dbbcd0-4958-40c4-b50a-84bbfbb96039"
  },
  {
    name: "Bauru De Alcatra Com Fritas",
    description: "Pão Cervejinha, Bife De Alcatra, Maionese, Tomate Em Rodelas, Folhas De Alface, Queijo, Ovo E Fritas. Serve 2 pessoas.",
    price: "R$ 59,00",
    image: "https://i.postimg.cc/NGSGjL8V/IMG_20250607_214652224_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=b3e26e55-7bcb-4fd4-9dc7-44010294891a"
  },
  {
    name: "Bauru De Filé Com Fritas",
    description: "Pão Cervejinha, Bife De Filé, Maionese, Tomate Em Rodelas, Folhas De Alface, Queijo, Ovo E Fritas. Serve 2 pessoas.",
    price: "R$ 66,00",
    image: "https://i.postimg.cc/wjTzfC7F/IMG-20250531-215109024-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=b3e26e55-7bcb-4fd4-9dc7-44010294891a"
  },
   {
    name: "Bauru Filé ",
    description: "Pão Cervejinha, Bife De Filé, Maionese, Tomate Em Rodelas, Folhas De Alface, Queijo E Ovo. Serve 1 pessoas.",
    price: "R$ 59,00",
    image: "https://i.postimg.cc/sfmY4k44/IMG_20250606_224433541_PORTRAIT.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=b3e26e55-7bcb-4fd4-9dc7-44010294891a"
  },
  {
    name: "Dog especial",
    description: "2 Salsicha, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Molho, Queijo Mussarela. Serve 1 pessoa.",
    price: "R$ 23,00",
    image: "https://i.postimg.cc/vmYsKpT3/IMG-20250531-205545910-PORTRAIT-2.jpg",
    category: "Lanches",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=4907a12a-d9f1-4166-bfab-68d72e518a51"
  },
  {
    name: "Dog Simples",
    description: "1 Salsicha, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Molho, Queijo Mussarela. Serve 1 pessoa.",
    price: "R$ 22,60",
    image: "/lovable-uploads/abd68998-91bc-4cb4-a7a2-dbb5366adcf2.png",
    category: "Lanches",
     ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=f3d35ca0-947d-45e0-a106-3732c6f5bf35"
  },
   {
    name: "Dog Linguiça",
    description: "1 Linguiça, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Molho, Queijo Mussarela. Serve 1 pessoa.",
    price: "R$ 27,50",
    image: "https://i.postimg.cc/s2LGvB3t/IMG_20250604_221137923_2.jpg",
    category: "Lanches",
     ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=f3d35ca0-947d-45e0-a106-3732c6f5bf35"
  },
  {
    name: "Dog Duas Linguiça",
    description: "2 Linguiça, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Molho, Queijo Mussarela. Serve 1 pessoa.",
    price: "R$ 32,00",
    image: "/lovable-uploads/abd68998-91bc-4cb4-a7a2-dbb5366adcf2.png",
    category: "Lanches",
     ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=f3d35ca0-947d-45e0-a106-3732c6f5bf35"
  },
   {
    name: "Dog Krecao",
    description: "Coração de frango, Maionese, Tomate, Alface, Milho, Mostarda, Catchup, Queijo Mussarela. Serve 1 pessoa.",
    price: "R$ 34,00",
    image: "https://i.postimg.cc/dtTJTt4s/IMG-20250526-203419001-PORTRAIT-2.jpg",
    category: "Lanches",
     ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=f3d35ca0-947d-45e0-a106-3732c6f5bf35"

  },
  {
    name: "Prensado",
    description: "Maionese, tomate, alface, presunto, queijo e ovo. Serve 1 pessoa.",
    price: "R$ 22,60",
    image: "/lovable-uploads/67740c08-faea-4884-a10e-2bca132fd95c.png",
    category: "Lanches",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=c39116ca-ba02-4a1c-b179-24a728753a36"
  },
   {
    name: "Torrada Americana",
    description: "Pão De Forma, Tomate, Alface, Pepino Conserva, Batata Palha, Presunto, Queijo, Ovo, Maionese.",
    price: "R$ 25,00",
    image: "https://i.postimg.cc/4xLX4vWQ/IMG_20250603_204827966_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=c39116ca-ba02-4a1c-b179-24a728753a36"
  },
    {
    name: "Hamburguer",
    description: "Pão Brioche,Maionese Caseira,Hamburguer Artesanal,Tomate,Alface,Cheddar.",
    price: "R$ 15,00",
    image: "https://i.postimg.cc/qvHJFJg8/IMG_20250604_204503746_PORTRAIT_2.jpg",
    category: "Lanches",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=87cac371-ac6b-4267-a5d5-126aa4feb969"
  },
  {
    name: "Ala Minuta De Bife Na Chapa",
    description: "Bife (Coxão De Dentro), Arroz, Feijão, Ovo, Salada e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 36,50",
    image: "/lovable-uploads/9b68fa7a-09c7-457c-bbe8-d6c68da3dff5.png",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=0c7c2e19-75c8-4329-9bdd-8e7a11f87a33"
  },
   {
    name: "Bifé A Cavalo",
    description: "Bife (Coxão De Dentro), Pão na Chapa, Salada, ovo e Batatas ou Polemta ou Aipin. Serve 1 pessoa.",
    price: "R$ 36,50",
    image: "https://i.postimg.cc/MTnVnQJc/IMG-20250515-WA0068.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=0338bd1a-9ac5-4a33-9e0f-c397fa6198f6"
  },
  {
    name: "Ala Minuta A Parmeggiana",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 56,00",
    image: "https://i.postimg.cc/PxnjVx1L/Screenshot-20250516-124402-851.png",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=296db838-4847-4dd3-9667-6d968a6e0af0"
  },
   {
    name: "Ala Minuta De Frango",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 41,00",
    image: "https://i.postimg.cc/cLdpTxpd/IMG-20250520-204133939-2.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=e8c81d3f-0201-492a-9da0-ff5aa643a2fc"
  },
  {
    name: "Ala Minuta De Bife Acebolado",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 43,50",
    image: "https://i.postimg.cc/J0JXqCnM/IMG-20250515-WA0067.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=fd337db4-6c4e-4f57-ad60-89b9f8985b21"
  },
  {
    name: "Ala Minuta De Frango A Milanesa",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 43,50",
    image: "https://i.postimg.cc/QtYgTKXJ/IMG-20250531-210449550-2.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=fd337db4-6c4e-4f57-ad60-89b9f8985b21"
  },
  {
    name: "Ala Minuta A Milanesa",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 43,50",
    image: "https://i.postimg.cc/vTwy6dRf/IMG_20250609_223842706_2.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=fd337db4-6c4e-4f57-ad60-89b9f8985b21"
  },
   {
    name: "Ala Minuta De Strogonoff",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 43,50",
    image: "https://i.postimg.cc/J0JXqCnM/IMG-20250515-WA0067.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=fd337db4-6c4e-4f57-ad60-89b9f8985b21"
  },
  {
    name: "Ala Minuta De Strogonoff",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 43,50",
    image: "https://i.postimg.cc/J0JXqCnM/IMG-20250515-WA0067.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=fd337db4-6c4e-4f57-ad60-89b9f8985b21"
  },
  {
    name: "Ala Minuta Lombo De Porco",
    description: "Bife, Arroz, Feijão, Ovo e Batatas ou Polemta ou Aipin. Serve 2 pessoa.",
    price: "R$ 43,50",
    image: "https://i.postimg.cc/qRsg0C24/IMG_20250613_221157530_3.jpg",
    category: "Pratos",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=fd337db4-6c4e-4f57-ad60-89b9f8985b21"
  },
  {
    name: "Iscas De Tilápia",
    description: "Iscas De Tilápia Empanadas 500g, Acompanha Ovos De Codorna, Pepino Conserva, Azeitonas, Limão",
    price: "R$ 75,00",
    image: "https://i.postimg.cc/bJcdKRDm/IMG_20250612_221434064_PORTRAIT_3.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=ace9aae0-c588-4c1f-8486-c15b28f9d0e3"
  },
  {
    name: "Frango Frito Crocante",
    description: "Iscas De Peito De Frango Empanado Crocante",
    price: "R$ 50,00",
    image: "https://i.postimg.cc/J4NJH8vQ/IMG-20250515-WA0059.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=8d4a8456-bc45-440a-87a4-ef9195d27e8a"
  },
   {
    name: "Picado Quente Com Fritas",
    description: "Calabresa ou Frango, Coração, Carne, Batata, Farinha Temperada E Ovo de Codorna",
    price: "R$ 50,00",
    image: "https://i.postimg.cc/Vv8tKsV4/IMG-20250515-202626490.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=8d4a8456-bc45-440a-87a4-ef9195d27e8a"
  },
   {
    name: "Bife a Xadrez",
    description: "Carne Amilanesa, Batata, Pepino E Ovo De Codorna",
    price: "R$ 50,00",
    image: "https://i.postimg.cc/qvrs1qyY/IMG-20250515-WA0072-1.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=8d4a8456-bc45-440a-87a4-ef9195d27e8a"
  },
   {
    name: "Pote de fritas com cheddar e bacon",
    description: "Porção de batata frita crocante com queijo cheddar e bacon.",
    price: "R$ 47,00",
    image: "https://i.postimg.cc/DzTPZsmm/IMG_20250603_210236505_PORTRAIT_3.jpg",
    category: "Porções",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqSqJ9Ljo9DXYUuINHpJt6E2maNZ8wkgLXgh8-dDb5VM3DEsrNt&prato=74c3c0c8-be5b-42ea-97e0-01baae4a15ce"
  },
  {
    name: "Fritas Pequena 250g",
    description: "",
    price: "R$ 21,00",
    image: "https://i.postimg.cc/B6BcsYbB/IMG_20250609_205106086_PORTRAIT_2.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=3612fbe3-44cf-4bd6-b0e1-e0d538828057"
  },
  {
    name: "Fritas Media 500g",
    description: "",
    price: "R$ 26,00",
    image: "https://i.postimg.cc/qMg8XYjH/IMG-20250602-204719855-2.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=3612fbe3-44cf-4bd6-b0e1-e0d538828057"
  },
  {
    name: "Fritas Grande 750g",
    description: "",
    price: "R$ 37,00",
    image: "https://i.postimg.cc/8zdpQ2rx/IMG_20250604_204107506_PORTRAIT_2.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=3612fbe3-44cf-4bd6-b0e1-e0d538828057"
  },
  {
    name: "Porção De Aipim Frito",
    description: "",
    price: "R$ 23,00",
    image: "https://i.postimg.cc/90XvMyH2/IMG_20250606_212928240_PORTRAIT_2.jpg",
    category: "Porções",
    ifoodUrl: "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?prato=3612fbe3-44cf-4bd6-b0e1-e0d538828057"
  },
  {
    name: "Refrigerante 2L",
    description: "Coca-Cola,Sprite, Fanta.",
    price: "R$ 20,00",
    image: "https://i.postimg.cc/1tpk31nT/download.jpg",
    category: "Bebidas",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=0afcae85-de1a-4439-8ffb-50b2281739f8"
  },
   {
    name: "Refrigerante 2L",
    description: "Guaraná .",
    price: "R$ 17,00",
    image: "https://i.postimg.cc/Y9Kc7C9Y/download.jpg",
    category: "Bebidas",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=d5fe3f9e-1620-46fc-86b2-1cdf57a66b85"
  },
  {
    name: "Refrigerante 600ml",
    description: "Coca-Cola, Guaraná, Sprite, Fanta.",
    price: "R$ 9,50",
    image: "https://i.postimg.cc/J0M9yYjh/download.jpg",
    category: "Bebidas",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=f9bdcdf6-b7e6-4aa1-8ec5-a9188bec6d76"
  },
  {
    name: "Cervejas Latão",
    description: "Amstel, Budweiser, Eisenbahn, Polar, Bohemia ou Skol.",
    price: "R$ 9,50",
    image: "https://i.postimg.cc/W4cSbFGN/download.jpg",
    category: "Bebidas",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=9dc11220-454d-4795-8b39-d2c959c83a62"
  },
  {
    name: "Cervejas Latão",
    description: "Heineken ou Stella Artois",
    price: "R$ 12,00",
    image: "https://i.postimg.cc/g2F3v9n4/images.jpg",
    category: "Bebidas",
    ifoodUrl:"https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqC_7TfWLiYZRiVXiY9cAycBV9RmFkJA4-hmMMTLR_gvKm_wPPg&prato=0747a558-f347-4173-b611-503011ebb0b8"
  }
];
